module.exports = __webpack_public_path__ + "static/media/crioDo_logo.016c3f3c.webp";